import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import LinkPreview from './components/LinkPreview';

app.initializers.add('datlechin/flarum-link-preview', () => {
  extend(CommentPost.prototype, 'refreshContent', function () {
    const getMultiDimensionalSetting = (key: string): string[] => {
      const setting = app.forum.attribute<string>(key);
      return setting ? setting.split(/[,\n]/).map((item) => item.trim()) : [];
    };

    const inList = (needle: string, haystack: string[]): boolean => {
      if (haystack.length === 0) {
        return false;
      }
      if (haystack.includes(needle)) {
        return true;
      }
      for (const item of haystack) {
        const quoted = item
          .replace(/[-\[\]\/{}()*+?.\\^$|]/g, '\\$&')
          .replace('\\*', '.*')
          .replace('\\?', '.');
        if (needle.match(new RegExp(quoted, 'i'))) {
          return true;
        }
      }
      return false;
    };

    const blacklistArray = getMultiDimensionalSetting('datlechin-link-preview.blacklist');
    const whitelistArray = getMultiDimensionalSetting('datlechin-link-preview.whitelist');
    const convertMediaUrls = app.forum.attribute<boolean>('datlechin-link-preview.convertMediaURLs') ?? false;
    const useGoogleFavicons = app.forum.attribute<boolean>('datlechin-link-preview.useGoogleFavicons') ?? false;
    const openLinksInNewTab = app.forum.attribute<boolean>('datlechin-link-preview.openLinksInNewTab') ?? false;
    const linkSelectorExcludes = ['.PostMention', '.UserMention', '.LinkPreview-link', '.LinkPreview-captured'].map((cls) => `:not(${cls})`).join('');

    this.element.querySelectorAll<HTMLAnchorElement>(`.Post-body a[rel]${linkSelectorExcludes}`).forEach((link) => {
      const normalizedUrl = link.href.replace(/^https?:\/\/(.+?)\/?$/i, '$1');

      if (
        (whitelistArray.length && !inList(normalizedUrl, whitelistArray)) ||
        (blacklistArray.length && inList(normalizedUrl, blacklistArray)) ||
        link.href.replace(/\/$/, '') !== (link.textContent?.replace(/\/$/, '') ?? '')
      ) {
        return;
      }

      if (convertMediaUrls && normalizedUrl.match(/\.(jpe?g|png|gif|svg|webp|mp3|mp4|m4a|wav)$/)) {
        return;
      }

      // 生成唯一 ID 并标记
      link.classList.add('LinkPreview-captured');
      const previewId = 'link-preview-' + Math.random().toString(36).substring(2, 11);

      // 将组件初态（Loading）渲染到游离容器
      const tempContainer = document.createElement('div');
      m.render(tempContainer, m(LinkPreview, {
        link,
        useGoogleFavicons,
        openLinksInNewTab,
        previewId
      }));

      // 提取生成的 DOM 并用原生 API 替换原始 a 标签
      if (tempContainer.firstElementChild) {
        link.replaceWith(tempContainer.firstElementChild);
      }
    });
  });
});